import { StyledGroup } from '@components/Group/styled';
import { StyledTitle } from '@components/Title/styled';
import Image from 'next/image';
import styled from 'styled-components';

export const StyledWorkItem = styled.div`
  margin-top: 7em;
  margin-bottom: 7em;

  @media screen and (min-width: 1024px) {
    padding: 0 15px;
    margin-top: 0;
    margin-bottom: 0;
    height: 100vh;
    max-width: 100%;
    display: grid;
    align-items: center;
    gap: 70px;
    grid-template-columns: 1.5fr 1fr;
  }
`;

export const StyledWorkImage = styled.div`
  width: 100%;
  max-width: 586px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  aspect-ratio: 8 / 5;
`;

export const StyledImage = styled(Image)`
  object-fit: contain;
  object-position: center;
  border-radius: 12px;
  box-shadow: 0px 6px 14px -2px rgba(21, 65, 99, 0.2), 0px 6px 14px 6px rgba(21, 65, 99, 0.1);
  /* @media screen and (min-width: 1024px) {
    border-radius: 0;
  } */
`;

export const StyledWorkContent = styled.div`
  width: 100%;
  max-width: 586px;
  margin: 0 auto;

  & > ${StyledTitle} {
    margin-bottom: 0;
    margin-top: 2em;

    &::first-letter {
      color: var(--color-primary);
    }

    @media screen and (min-width: 1024px) {
      margin-top: 0
    }
  }
`;

export const StyledWorkSection = styled.div`
  margin-top: 3em;

  & > ${StyledGroup} {
    flex-wrap: wrap;
  }

  & a {
    color: var(--color-text);
    font-size: 1.5rem;
    font-weight: 500;
  }
`;

export const StyledWorkYear = styled.p`
  font-weight: 600;
  font-size: 1.4rem;
  margin-top: .6em;
`;